import React from "react";
import { Portal } from "react-overlays";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import { withTranslation } from "react-i18next";

const DateRangeFilter = ({ t, dateRange, setDateRange }) => {
  const fromDate = dateRange?.fromDate ?? null;
  const toDate = dateRange?.toDate ?? null;

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");
    return el ? <Portal container={el}>{children}</Portal> : <>{children}</>;
  };

  const update = (field, value) => {
    setDateRange((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="invitation_date_picker">
      <div className="invitation_date">
        <div className="c-field">
          <label>{t("from")}</label>
          <div className="d-flex inputdate">
            <ReactDatePickerCommon
              dateFormat="dd-MM-yyyy"
              className="c-form-control"
              selected={fromDate}
              onChange={(date) => update("fromDate", date)}
              maxDate={toDate}
              popperPlacement="bottom-start"
              popperContainer={CalendarContainer}
            />
          </div>
        </div>
      </div>
      <div className="invitation_date">
        <div className="c-field">
          <label>{t("to")}</label>
          <div className="d-flex inputdate">
            <ReactDatePickerCommon
              dateFormat="dd-MM-yyyy"
              className="c-form-control"
              selected={toDate}
              minDate={fromDate}
              onChange={(date) => update("toDate", date)}
              popperPlacement="bottom-end"
              popperContainer={CalendarContainer}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(DateRangeFilter);
